import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {DjPsycho} from "../DjPsycho";
import {SimpleReelModel} from "../../core/reel/simplereel/SimpleReelModel";
import {DjPsychoSymbol, DjPsychoSymbolStates} from "../reels/DjPsychoSymbol";
import {DjPsychoGameMode} from "../server/DjPsychoGameMode";

/**
 * Created by Jerker Nord on 2021-01-28.
 */

export class DjPsychoZeroBetIdlePresentation implements FlowStatePresentation {

    public start(flowStateController: FlowStateController): void {
        let fsLeft: number;
        DjPsycho.apiPlugin.betHandler.zeroBet();

        if (!DjPsycho.model.isRestore) {
            fsLeft = DjPsycho.model.gameData.freespinsLeft - 1;

            // #66
            if (DjPsycho.model.data.nextMode.indexOf("AVALANCHE") === -1) {
                DjPsycho.model.fsLeftCount = fsLeft;
                DjPsycho.keypadPlugin.setZeroBetSpinCounter(fsLeft);
            }
        } else {
            fsLeft = DjPsycho.model.initData.freespinsLeft;

            // #66
            if (DjPsycho.model.data.nextMode.indexOf("AVALANCHE") === -1 || DjPsycho.model.data.nextMode === DjPsychoGameMode.NORMAL_AVALANCHE || DjPsycho.model.data.mode === DjPsychoGameMode.NORMAL_AVALANCHE) {
                fsLeft -= 1;
            }

            DjPsycho.model.fsLeftCount = fsLeft;
            DjPsycho.keypadPlugin.setZeroBetSpinCounter(fsLeft);
        }

        DjPsycho.reelView.reelModels.forEach((reel: SimpleReelModel) => {
            reel.symbols.forEach((symbol: DjPsychoSymbol) => {
                symbol.setState(DjPsychoSymbolStates.NORMAL);
            });
        });

        flowStateController.finish();
    }
}